export const dashboardWidget = {
  props: {
    data: {
      type: [Object, Array],
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    actionHandler: {
      type: Function,
      default: () => void 0
    }
  }
};
